import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"
import ImportJobActionResult from "./Model/ImportJobActionResult"

export default function ImportJobStartObservable(importJobID: number, poolID: number): Observable<ImportJobActionResult> {
  const params: string = JSON.stringify({
    ImportJobID: importJobID,
    PoolID: poolID
  })
  return ObservableFromFetch<ImportJobActionResult>("WorkforceImport/StartImport", params)
}
